import { ChevronRight } from "lucide-react"
import { memo } from "react"
import { NavLink } from "react-router"
import { cn } from "@/lib/utils"

const SETTINGS_NAV_ITEMS = [
  { to: "/setting/shop", label: "店舗情報" },
  { to: "/setting/members", label: "メンバー" },
  { to: "/setting/tickets", label: "チケットもぎり方法" },
] as const

type TenantSettingsNavProps = {
  ariaLabel: string
}

export const TenantSettingsNav = memo(function TenantSettingsNav({
  ariaLabel,
}: TenantSettingsNavProps) {
  return (
    <nav
      aria-label={ariaLabel}
      className="flex shrink-0 flex-col gap-2 border-b border-border pb-4 lg:min-h-[711px] lg:w-44 lg:gap-3 lg:border-b-0 lg:border-r lg:pb-0 lg:pr-4 lg:pt-10"
    >
      {SETTINGS_NAV_ITEMS.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          className={({ isActive }) =>
            cn(
              "flex h-7 items-center gap-0.5 px-2 text-[13px] font-semibold leading-[1.35] text-foreground transition-colors hover:text-secondary",
              "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2",
              isActive && "text-secondary"
            )
          }
        >
          {({ isActive }) => (
            <>
              <span>{item.label}</span>
              {isActive ? <ChevronRight className="size-4 shrink-0" strokeWidth={2.25} /> : null}
            </>
          )}
        </NavLink>
      ))}
    </nav>
  )
})
